// extracted by mini-css-extract-plugin
export default {"kaderGrid":"Kader_kaderGrid__4je0a","card":"Kader_card__bM3Yc"};